export default __webpack_public_path__ + "static/media/cookies-accepted.de15b8f3.svg";